import Vue from 'vue';
import * as queries from 'lib/graphql/queries';
import storefront from 'lib/storefront';
import { mapState } from 'vuex';
import {
  convertGQLToProductJson,
  getStarsHTML,
  formatPrice,
} from 'utils/general';

export default Vue.component('product-compare-item', {
  components: {
    'vue-image': () => import('../vue-image/vue-image.vue'),
  },
  props: ['product', 'first', 'factors', 'scores'],
  data: () => ({
    productObject: null,
    compareFactors: [],
    compareScores: [],
  }),
  async mounted() {
    this.compareFactors = this.factors.split('|');
    this.compareScores = this.scores.split('|');
    await this.getProductData();
    this.$emit('mounted');
  },
  computed: {
    ...mapState('global'),
    title() {
      if (!Boolean(this.productObject)) return '';
      return this.productObject.title
        .split(__GLOBAL__.productDelimiter)[0]
        .trim();
    },
    price() {
      if (!Boolean(this.productObject)) return '';
      return formatPrice(this.productObject.price);
    },
    image() {
      if (!Boolean(this.productObject)) return '';
      return this.productObject.media[0].src;
    },
    altText() {
      if (!Boolean(this.productObject)) return '';
      return this.productObject.media[0].alt;
    },
  },
  methods: {
    async getProductData() {
      const response = await storefront.request(queries.product, {
        handle: this.product,
      });
      this.productObject = convertGQLToProductJson(response.product);
    },
    getRatingContent() {
      if (!Boolean(this.productObject)) {
        return '';
      }

      const rating = this.products[index].metafields?.yotpo?.reviews_average;
      const ratingCount = this.products[index].metafields?.yotpo?.reviews_count;
      return `${getStarsHTML(rating)} ${ratingCount} Reviews`;
    },
    getScoreContent(factor, index) {
      if (factor.toLowerCase() === 'rating') {
        return this.getRatingContent();
      }
      return this.compareScores[index];
    },
  },
  template: `
    <div class="product-compare__product" :class="{'product-compare__product--first': first }">
      <div class="product-compare__product-wrapper">
        <div class="product-compare__product-top">
          <div class="product-compare__image-wrapper">
            <vue-image
              :full-width="true"
              fit="cover"
              :src="image"
              :alt="title"
              :lazy="true"
              width="205px"
              height="256px"
            >
            </vue-image>
          </div>
          <h3 class="product-compare__product-title bold uppercase p1" v-text="title"></h3>
          <p
            class="product-compare__product-price OneLinkNoTx h6"
            v-text="price"
          >
          </p>
        </div>
        <div class="product-compare__product-values">
          <div
            class="product-compare__product-cell"
            v-for="(factor, index) in compareFactors"
          >
            <p class="product-compare__product-factor p1" v-text="factor"></p>
            <p
              class="product-compare__product-score p1"
              v-html="getScoreContent(factor, index)"
            >
            </p>
          </div>
        </div>
      </div>
    </div>
  `,
});
